import React, { useState } from 'react';
import Helmet from 'react-helmet';
import ReactDOM from 'react-dom';
import { Inertia } from '@inertiajs/inertia';
import { InertiaLink, usePage } from '@inertiajs/inertia-react';
import AdminLayout from '../../../Shared/AdminLayout';
import ProfileCard from '../../../Shared/ProfileCard';
import DataCard from '../../../Shared/DataCard';
import DataContainer from '../../../Shared/DataContainer';
import Icon from '../../../Shared/Icon';
import classNames from 'classnames';
import TextInput from '../../../Shared/TextInput';
import FileInput from '../../../Shared/FileInput';
import SelectInput from '../../../Shared/SelectInput';
import TextArea from '../../../Shared/TextArea';
import LoadingButton from '../../../Shared/LoadingButton';

function Show() {
     const { auth, errors, data } = usePage().props;
     const [sending, setSending] = useState(false);
     const [values, setValues] = useState({

     });

     const iconClasses = classNames('w-4 h-4 mr-2', {
          'text-white fill-current': false,
          'text-gray-500 hover:text-white fill-current': true
     });

     function handleChange(e) {

     }

     return (
          <React.Fragment key="permission-c">
               <Helmet>
                    <title>Products</title>
               </Helmet>
               <ProfileCard>
                    <div className="md:col-span-1">
                         <div className="px-4 sm:px-0">
                              <h3 className="text-lg font-small text-gray-600">View Product</h3>
                              <h3 className="text-lg font-medium text-gray-900">{data.name}</h3>
                              <p className="mt-1 text-sm text-gray-600">
                                   {data.description}
                              </p>
                              <div className="hidden sm:block">
                                   <div className="py-8">
                                        <div className="border-t border-gray-400"></div>
                                   </div>
                              </div>
                              <p className="w-full font-small text-gray-600">Code: <span className="font-bold float-right">{data.code}</span></p>
                              <p className="w-full font-small text-gray-600">Type : <span className="font-bold float-right">{data.type}</span></p>
                              <p className="w-full font-small text-gray-600">Price: <span className="font-bold float-right">{data.currency} {data.price}</span></p>
                              <p className="w-full font-small text-gray-600">Qty Available: <span className="font-bold float-right">{data.available}</span></p>
                              <p className="w-full font-small text-gray-600">Qty Alert: <span className="font-bold float-right">{data.alert}</span></p>
                         </div>
                    </div>
                    <DataCard>
                         <form>
                              <div className="px-4 py-5 sm:p-6">
                                   <div className="grid grid-cols-3 gap-3">
                                        <div className="col-span-12 text-right">
                                             <InertiaLink href={route('product.edit', data.id)} className="float-left border border-blue-500 text-sm text-blue-500 p-2 rounded focus:outline-none hover:bg-blue-600 hover:text-blue-100 inline-flex items-center">
                                                  <Icon name="eye" className={iconClasses} />
                                                  Edit
                                             </InertiaLink>
                                             <InertiaLink href={route('product.index')} className="bg-transparent border border-gray-500 text-sm text-gray-500 p-2 rounded focus:outline-none hover:bg-gray-600 hover:text-gray-100 inline-flex items-center">
                                                  <Icon name="back" className={iconClasses} />
                                                  Back
                                             </InertiaLink>
                                        </div>
                                        <div className="col-span-6 sm:col-span-12">
                                             <div className="mt-2">
                                                  <img src={`https://ui-avatars.com/api/?name=Produit&amp;color=7F9CF5&amp;background=EBF4FF`} className="rounded-full h-20 w-20" />
                                             </div>
                                             {data.packDetails.length > 0 &&(
                                                  <React.Fragment>
                                                       <div className="hidden sm:block">
                                                            <div className="py-8">
                                                                 <div className="border-t border-gray-400"></div>
                                                            </div>
                                                       </div>
                                                       <ul className="overflow-auto h-128 list-none pt-2 mt-2">
                                                            {data.packDetails.map(({id, name, code, type, description}) => {
                                                                 return <li className={`p-2 mt-2 rounded hover:bg-gray-200 hover:shadow-md`} key={id}>
                                                                      <label className="flex items-center" htmlFor="perms">
                                                                           <span className="font-semibold ml-2 text-sm text-gray-700">{name} ({code})</span>
                                                                      </label>
                                                                      <p className="text-gray-400 pl-6">{type}</p>
                                                                      <p className="text-sm text-gray-500 pl-6">{description}</p>
                                                                 </li>
                                                            })}
                                                       </ul>
                                                  </React.Fragment>
                                             )}
                                        </div>
                                   </div>
                              </div>
                         </form>
                    </DataCard>
               </ProfileCard>
          </React.Fragment>
     );
}

// Persisten layout
// Docs: https://inertiajs.com/pages#persistent-layouts
Show.layout = page => <AdminLayout children={page} header={'Show Product'} />;

export default Show;
